const auth = {
  BASE: 'auth',
  MAIN: undefined,
};
auth.MAIN = `${auth.BASE}|Auth`
export default {
  ...auth
}
